import { render, staticRenderFns } from "./Pbj.vue?vue&type=template&id=3db63c74&"
import script from "./Pbj.vue?vue&type=script&lang=js&"
export * from "./Pbj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports